<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17L79bw/tc-custom/9780802196347.jpg?1698195306138" alt="This image is the cover for the book Middleman"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Middleman
      </h1>
      <p class="bookDescription body article font2">
        <b>A National Book Critics Circle Award winner and <i>New York Times</i> Notable Book: “intelligent, versatile . . . profound” stories of migration in America (<i>The Washington Post Book World</i>).</b><br/>  <br/> Illuminating a new world of people in migration that has transformed the essence of America, these collected stories are a dazzling display of the vision of this critically-acclaimed contemporary writer.<br/>  <br/> An aristocratic Filipina negotiates a new life for herself with an Atlanta investment banker. A Vietnam vet returns to Florida, a place now more foreign than the Asia of his war experience. An Indian widow tries to explain her culture’s traditions of grieving to her well-intentioned friends. And in the title story, an Iraqi Jew whose travels have ended in Queens suddenly finds himself an unwitting guerrilla in a South American jungle.<br/>  <br/> Passionate, comic, violent, and tender, these stories draw us into a cultural fusion in the midst of its birth pangs, expressing a “consummated romance with the American language” (<i>The New York Times Book Review</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bharati Mukherjee
      </h2>
      
      <p class="authorDescription body article">BHARATI MUKHERJEE (1940-2017) is the author of over a dozen books, short-story collections, and works of nonfiction. In 1988 she became the first naturalized American citizen to win the National Book Critics Circle award for her collection The Middleman and Other Stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press New York
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?713b6b4e